import React, { Component } from 'react';
import { StaticQuery, graphql } from 'gatsby';
import smoothscroll from 'smoothscroll-polyfill';
import {
  SEO,
  Footer,
  Header,
} from '.';
import { MobileNavigation } from './Mobile';
import '../sass/global/styles.scss';
import 'typeface-libre-franklin';
import 'typeface-spacegrotesk';
import 'typeface-rock-salt';

const isClient = typeof window !== 'undefined';
const viewportUnitsBuggyfill = isClient ? require('viewport-units-buggyfill') : null;

const MOBILE_BREAKPOINT = 1080;

class PureLayout extends Component {
  state = {
    navOpen: false,
    viewportTopPos: 0,
    viewportWidth: 0,
  };

  componentDidMount() {
    if (isClient) {
      viewportUnitsBuggyfill.init();
      smoothscroll.polyfill();
      this.handleScroll();
      this.updateWindowDimensions();
      window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('resize', this.updateWindowDimensions);
      window.addEventListener('keydown', this.handleEscKey);
    }
  }

  componentWillUnmount() {
    if (isClient) {
      window.removeEventListener('keydown', this.handleEscKey);
      window.removeEventListener('resize', this.updateWindowDimensions);
      window.removeEventListener('scroll', this.handleScroll);
    }
  }

  handleEscKey = (event) => {
    const { navOpen } = this.state;
    if (event.keyCode === 27 && navOpen) this.closeNav(event);
  }

  handleScroll = () => {
    const viewportTopPos = window.scrollY;
    this.setState({ viewportTopPos });
  }

  updateWindowDimensions = () => {
    this.setState({ viewportWidth: window.innerWidth });
  }

  toggleNav = (event) => {
    event.preventDefault();
    const { navOpen } = this.state;
    if (event) event.preventDefault();
    if (navOpen) document.body.classList.remove('nav-open');
    if (!navOpen) document.body.classList.add('nav-open');
    this.setState({
      navOpen: !navOpen,
    });
  };

  openNav = (event) => {
    if (event) event.preventDefault();
    document.body.classList.add('nav-open');
    this.setState({
      navOpen: true,
    });
  };

  closeNav = () => {
    document.body.classList.remove('nav-open');
    this.setState({
      navOpen: false,
    });
  };

  render() {
    const {
      navOpen,
      viewportTopPos,
      viewportWidth,
    } = this.state;
    const {
      children,
      location,
      settings,
      seoData,
    } = this.props;
    const {
      metaTitle = null,
      metaDescription = null,
      openGraphImage = null,
    } = seoData;
    const isMobile = Boolean(viewportWidth <= MOBILE_BREAKPOINT);
    const isHome = Boolean(location.pathname === '/');
    const pathParts = location.pathname.split('/').filter(part => part !== '');
    const pageId = isHome ? 'home' : pathParts.join('-');
    return (
      <>
        <SEO
          title={metaTitle && metaTitle.text}
          desc={metaDescription && metaDescription.text}
          banner={openGraphImage && openGraphImage.url}
          pathname={location.pathname}
        />
        <div id="app" className="app">
          <Header
            location={location}
            settings={settings}
            navOpen={navOpen}
            isMobile={isMobile}
            viewportTopPos={viewportTopPos}
            toggleNavHandler={event => this.toggleNav(event)}
          />
          { isMobile && (
            <MobileNavigation
              location={location}
              settings={settings}
              navOpen={navOpen}
              toggleNavHandler={event => this.toggleNav(event)}
              closeNav={event => this.closeNav(event)}
            />
          )}
          <main id={isHome ? 'home' : pageId}>
            {children}
          </main>
          <Footer
            location={location}
            settings={settings}
          />
        </div>
      </>
    );
  }
}

class Layout extends Component {
  render() {
    return (
      <StaticQuery
        query={graphql`
          query LayoutQuery {
            settings: prismicSettings {
              data {
                email {
                  text
                }
                footerServiceTitle: footer_service_title {
                  text
                }
                footerServiceDescription: footer_service_description {
                  text
                }
                footerLocationTitle: footer_location_title {
                  text
                }
                footerLocationDescription: footer_location_description {
                  text
                }
                socialLinks: social_links {
                  type
                  link {
                    url
                    target
                  }
                }
                primaryMenu: primary_menu {
                  title {
                    text
                  }
                  pageLink: page_link {
                    link_type
                    uid
                    slug
                    url
                  }
                }
              }
            }
          }
        `}
        render={data => <PureLayout {...this.props} settings={data.settings.data} />}
      />
    );
  }
}

export default Layout;
